import { ColorSchemeTypes } from "../../types/ColorScheme"
import normalizeImage, { NormalizedImageData, RawImageData } from "../base/ImageBase"
import { TagProps } from "../base/Tags"

export interface RawCardUseCasesData {
  id: number
  colorScheme: ColorSchemeTypes
  title: string
  slug: string
  description: string
  createdAt: string
  updatedAt: string
  publishedAt: string
  locale: string
  image: RawImageData
  tags: TagProps[]
  originalSlug: string
  href: string
  categories: TagProps[]
}

export interface NormalizedCardUseCasesData extends RawCardUseCasesData {
  image: NormalizedImageData
}

const CardUseCases = (item: RawCardUseCasesData): NormalizedCardUseCasesData => {
  const { colorScheme, title, slug, image, tags, locale, description } = item

  return {
    ...item,
    href: `${locale === 'it' ? 'use-cases' : 'use-cases'}/${slug}`,
    image: normalizeImage(image),
    colorScheme,
    title,
    description,
    categories: tags
  }
}

export default CardUseCases